
/* globals Store */
export function showErrorMessage (text) {
  Store.commit("common/setSysmsg", true);
  Store.commit("common/setSysmsgText", text);
  Store.commit("common/setSysmsgTitle", "Error");  
}

export function showSuccessMessage (text) {  
  Store.commit("common/setSysmsg", true);
  Store.commit("common/setSysmsgText", text);
  Store.commit("common/setSysmsgTitle", "Success");    
}

export function showProgress (text) {  
  Store.commit("common/setSysloading", true);  
  Store.commit("common/setSysloadingTitle", text);  
}

export function hideProgress () {  
  Store.commit("common/setSysloading", false);  
}

export function alertSuccess (text) {  
  Store.commit("common/setSysalertTitle", "success");  
  Store.commit("common/setSysalertText", text);  
}

export function closeAlert (timeout) {
  setTimeout(() => {    
    Store.commit("common/setSysalert", false);
  }, timeout);
}

export function commitRetDataSets (commit, resdata) {
  var jsonInfo = JSON.stringify(resdata);
  var trset = JSON.parse(jsonInfo);
  var trSetName = trset.TrSetName;
  console.log("Return TrSet : " + trSetName);
  var datasets = trset.DataSets;

  for (var i = 0; i < datasets.length; i++) {
    var dataset = datasets[i];
    var datarows = dataset.DataRows;        
    console.log('---commit(' + dataset.DataSetName + ')----');
    commit(dataset.DataSetName, datarows);    
  }
}

export function handleResponseError (error) {
  if (error.response) {
    // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
    console.log("------요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다. ---------------");
    showErrorMessage(error.response.data);      
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    console.log('Error', error.message);
  }
  else if (error.request) {
    console.log("------요청이 이루어 졌으나 응답을 받지 못했습니다. ---------------");
    showErrorMessage("No Response");
    // 요청이 이루어 졌으나 응답을 받지 못했습니다.
    // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
    // Node.js의 http.ClientRequest 인스턴스입니다.
    console.log(error.request);
  }
  else {
    console.log("------오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다. ---------------");
    // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
    showErrorMessage(error.message);
    console.log('Error', error.message);
  }
  console.log(error.config);  
}
